var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var _ = require('lodash');

var breakpoint_mobile = 455;
var breakpoint        = 1023;
var container         = '.carousel.carousel--card';
var target            = '.card .background-image';
var events            = 'carousel--events';
var slick_placeholder = 'slick-placeholder';
var ratio             = 1;

var ratios = {
    'card--events': 1,
    'card--banner': 1.3
};

var resize = {

    equalHeight: _.debounce(function(e) {
        $(container).each(function(index) {
            // Ratio
            $(container).each(function(index) {
                $(this).find(target).parent().parent().each(function() {
                    if ($(this).hasClass(Object.keys(ratios)[index])) {
                        ratio = Object.values(ratios)[index];
                    }
                });
                // Set ratio
                $(this).find(target).height($(this).find(target).width() * ratio);
                // Set container height
                $(this).height($(this).find(target).height());
            });
            $(this).find(target).height($(this).find(target).width() * ratio);
        });

        // add empty item to the slider to show last offset slider and stop sliding on desktop
        if ($(window).width() > breakpoint_mobile) {
            // stop sliding
            $('.'+events).slick("slickSetOption", "draggable",false);
            // remove placeholder slide
            if ($('.'+slick_placeholder).length > 1) {
                $(container).each(function() {
                    $(this).slick('slickRemove', $(this).find('.'+slick_placeholder).data('slick-index'));
                });
            }

        } else {
            // start sliding
            $('.'+events).slick("slickSetOption", "draggable",true);
            // add plceholder slide
            if ($('.'+slick_placeholder).length < 1) $(container).slick('slickAdd', '<div class="'+slick_placeholder+'"></div>');
        };
    }, 100)

};

$(window).on('load', function() { $(container).addClass('load'); });
$(window).on('load resize', _.bind(resize.equalHeight, resize));

module.exports  = function() { /* Nothing to Export */ };
